var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedRxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4395 5.91869L28.748 0.227145C28.6026 0.0817518 28.4049 0 28.199 0H0.776119C0.347702 0 0 0.347184 0 0.776119V33.8905C0 34.3195 0.347702 34.6667 0.776119 34.6667H33.8905C34.319 34.6667 34.6667 34.3195 34.6667 33.8905V6.46766C34.6667 6.26121 34.5849 6.06408 34.4395 5.91869ZM9.31343 1.55172H25.3532V12.4174H9.31343V1.55172ZM28.4577 33.1139H6.20896V19.6612H28.4577V33.1139ZM33.1144 33.1139H30.01V18.8851C30.01 18.4561 29.6623 18.1089 29.2338 18.1089H5.43284C5.00442 18.1089 4.65672 18.4561 4.65672 18.8851V33.1139H1.55224V1.55172H7.76119V13.1935C7.76119 13.6224 8.1089 13.9696 8.53731 13.9696H26.1294C26.5578 13.9696 26.9055 13.6224 26.9055 13.1935V1.55172H27.8777L33.1144 6.78846V33.1139Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedRxIcon);
export default __webpack_public_path__ + "static/media/SavedRxIcon.19304e1cdf833a143dd4809df4e2a1d7.svg";
export { ForwardRef as ReactComponent };